module.exports = __webpack_public_path__ + "img/img_32419_0_7.30f9427c.png";